<template>
  <div></div>
</template>

<script>
import Session from '@/api/session'
import { mapActions } from 'vuex'

export default {
  name: 'signout',
  mounted () {
    this.signout()
  },
  methods: {
    ...mapActions({
      authReset: 'authReset',
      sipuaUnregister: 'sipuaUnregister'
    }),
    signout () {
      Session.clear()
      this.authReset()
      this.sipuaUnregister()
      location.reload(true)
    }
  }
}
</script>

<style>
</style>
